import Backbone from 'backbone';
import Payout from './payout';

var PayoutCollection = Backbone.Collection.extend({
  model: Payout,
});

export default  PayoutCollection;
